import {
  FILE_TRANSFER_PROMO_DESKTOP_QUERY,
  FILE_TRANSFER_PROMO_END_AT,
} from "./fileTransferPromo.constants";

const HTML_TAG_PATTERN = /<[^>]*>/g;
const NON_BREAKING_SPACE_ENTITY_PATTERN = /&nbsp;/g;

const getCurrentUrl = () => {
  if (typeof window === "undefined") return "http://localhost/";

  return window.location.href;
};

/**
 * @param {{ url?: string }} options
 * @returns {boolean}
 */
export const isFileTransferPromoRouteAllowed = ({
  url = getCurrentUrl(),
} = {}) => !new URL(url).searchParams.has("title");

/**
 * @param {{ mediaQuery?: string }} options
 * @returns {boolean}
 */
export const isDesktopFileTransferPromoViewport = ({
  mediaQuery = FILE_TRANSFER_PROMO_DESKTOP_QUERY,
} = {}) => {
  if (typeof window === "undefined" || !window.matchMedia) return false;

  return window.matchMedia(mediaQuery).matches;
};

/**
 * @param {{ currentTime?: number, endAt?: number }} options
 * @returns {boolean}
 */
export const isFileTransferPromoWithinWindow = ({
  currentTime = Date.now(),
  endAt = FILE_TRANSFER_PROMO_END_AT,
} = {}) => currentTime < endAt;

/**
 * @param {string | null | undefined} value
 * @returns {boolean}
 */
export const isBlankPromoText = (value = "") => !String(value ?? "").trim();

/**
 * @param {string | null | undefined} noteContent
 * @returns {boolean}
 */
export const isBlankPromoContent = (noteContent = "") => {
  const plainContent = String(noteContent ?? "")
    .replace(HTML_TAG_PATTERN, "")
    .replace(NON_BREAKING_SPACE_ENTITY_PATTERN, " ");

  return isBlankPromoText(plainContent);
};

/**
 * @param {{
 *   currentTime?: number,
 *   hasAllowedRoute: boolean,
 *   hasSeenPromo: boolean,
 *   isDesktop: boolean,
 *   noteContent?: string,
 *   noteTitle?: string
 * }} options
 * @returns {boolean}
 */
export const isFileTransferPromoEligible = ({
  currentTime = Date.now(),
  hasAllowedRoute,
  hasSeenPromo,
  isDesktop,
  noteContent = "",
  noteTitle = "",
}) => {
  if (!hasAllowedRoute || !isDesktop || hasSeenPromo) return false;
  if (!isFileTransferPromoWithinWindow({ currentTime })) return false;

  return isBlankPromoText(noteTitle) && isBlankPromoContent(noteContent);
};
